const settings = {
    label: "GDPR",
    name: "gdpr",
    file: "site/data/gdpr.yaml",
    fields: [
        {
            label: "Simple Cookie Consent",
            name: "consent",
            widget: "object",
            fields: [
                { label: "Message", name: "message", widget: "string", default: "This website uses cookies to ensure you get the best experience on our website.", i18n: true},
                { label: "Dismiss", name: "dismiss", widget: "string", default: "Got it!", required: false, i18n: true },
                { label: "type", name: "type", widget: "select", default: "opt-in", options: ["opt-in", "categories"], i18n: true },
                { label: "Label", name: "link", widget: "string", default: "Privacy Policy", required: false, i18n: true },
                { label: "Url", name: "url", widget: "string", required: false, i18n: true },
                { label: "Popup Background Color", name: "p_bg", widget: "color", required: false, default:"#efefef", picker: "sketch", presetColors: [ "#FFFFFF", "#000000", "#efefef"],
                    i18n: true },
                { label: "Popup Text Color", name: "p_txt", widget: "color", required: false, default:"#404040", picker: "sketch", presetColors: [ "#FFFFFF", "#000000", "#404040"],
                    i18n: true },
                { label: "Button Background Color", name: "b_bg", widget: "color", required: false, default:"#2e3691", picker: "sketch", presetColors:[ "#FFFFFF", "#000000", "#2e3691"],
                    i18n: true },
                { label: "Button Text Color", name: "b_txt", widget: "color", required: false, default:"#ffffff", picker: "sketch",  presetColors: [ "#FFFFFF", "#000000", "#ffffff"],
                    i18n: true }
            ]
        },
        {
            label: "Use Osana Cookie Content",
            name: "osana",
            widget: "object",
            hint: "Premium Service (Payable)",
            collapsed: true,
            fields: [
                { label: "Osana on/off", name: "active", widget: "boolean", default: false, required: false, i18n: true },
                { label: "Script" , name: "script", widget: "string", required: false, i18n: true  }
            ]
        }
    ]
}


export default settings;
